import { ComponentPropsWithoutRef } from "react";
import * as styles from "./WrapperContentMask.css";
import { SubtractMask } from "~/assets/svgs/SubtractMask";
import clsx from "clsx";

export type WrapperContentMaskProps = ComponentPropsWithoutRef<"div"> & {};

export const WrapperContentMask = ({ className, children }: WrapperContentMaskProps) => {
  return (
    <div className={clsx(className, styles.wrapper)}>
      <SubtractMask className={styles.subtractMask({layout: 'top'})}/>
      {children}
      <SubtractMask className={styles.subtractMask({layout: 'bottom'})}/>
    </div>
  );
};
